import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import Checkbox from '@material-ui/core/Checkbox';

import ContentsAllItem from './ContentsAllItem';
import Pagination from '../Common/Pagination';
import SiteFinder from '../OpbMng/SiteFinder';
import { roles } from '../../constants';
import { boardService } from '../../services';
import { alertActions } from '../../modules/alert';
import { SiteNumInputSiteFinder } from '../Common/InputBox';

class ContentsAllMng extends Component {
    constructor(props) {
        super(props);
        // 로그인 한 사람이 지사운영자 일 경우 해당 지사의 컨텐츠만 검색
        const { myInfo } = this.props;
        const isAdministratorRole = myInfo.myRole === roles.administratorRole;
        const damdang = myInfo.company.split(",");

        this.state = {
            opbSearch: {
                damdangOrg: (isAdministratorRole ? damdang[0] : ''),
                damdangRegion: (isAdministratorRole ? damdang[1] : ''),
                damdangOffice: (isAdministratorRole ? damdang[2] : ''),
                siteName: '',
                siteNum: '',
                searchTypeCodes: [" ", "CK002", "CK003"],
                boardTypeCodes: ["BK001"],
            },
            usedOpbSearch: null,
            contentsList: {
                totalCount: 0,
                currentPage: 1,
                totalPage: 1,
                start: 1,
                listCount: 10,
                startPage: 1,
                endPage: 1,
                boardList: '',
            },
            isAdministratorRole: isAdministratorRole,
            isMobile: false,
        }

        this.setStateContentsList();
    }

    setRefresh = () => {
        this.setState({
            opbSearch: {
                damdangOrg: (this.state.isAdministratorRole ? this.state.opbSearch.damdangOrg : ''),
                damdangRegion: (this.state.isAdministratorRole ? this.state.opbSearch.damdangRegion : ''),
                damdangOffice: (this.state.isAdministratorRole ? this.state.opbSearch.damdangOffice : ''),
                siteName: '',
                siteNum: '',
                searchTypeCodes: [" ", "CK002", "CK003"],
                boardTypeCodes: ["BK001"],
            },
            usedOpbSearch: null,
            contentsList: {
                ...this.state.contentsList,
                currentPage: 1,
                listCount: 10
            }
        }, () => { this.setStateContentsList(); })

    };

    componentDidMount = () => {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        let isMobile = (window.innerWidth < 992);
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile: isMobile });
        }
    }

    setStateContentsList = async () => {
        const { damdangOffice, siteNum, boardTypeCodes, searchTypeCodes } = this.state.opbSearch;
        const { currentPage, listCount } = this.state.contentsList;
        let formData = new FormData();
        if (siteNum !== "") formData.append('siteNum', siteNum);
        formData.append('boardTypeCodes', boardTypeCodes);
        formData.append('contentKindCodes', searchTypeCodes);
        formData.append('currentPage', currentPage);
        formData.append('listCount', listCount);

        if (!this.state.isAdministratorRole) {
            boardService.findContentsList(formData)
                .then(response => {
                    this.setState({
                        usedOpbSearch: this.state.opbSearch,
                        contentsList: response.data
                    });
                })
                .catch(this.handleErrors);
        }
        else {
            formData.append('damdangOffice', damdangOffice);

            boardService.findContentsListByOffice(formData)
                .then(response => {
                    this.setState({
                        contentsList: response.data,
                        usedOpbSearch: this.state.opbSearch
                    });
                })
                .catch(this.handleErrors);
        }

    };

    handleSiteInfo = (siteInfo) => {
        this.setState({
            opbSearch: {
                ...this.state.opbSearch,
                damdangOrg: (this.state.isAdministratorRole ? this.state.opbSearch.damdangOrg : siteInfo.damdangOrg),
                damdangRegion: (this.state.isAdministratorRole ? this.state.opbSearch.damdangRegion : siteInfo.damdangRegion),
                damdangOffice: (this.state.isAdministratorRole ? this.state.opbSearch.damdangOffice : siteInfo.damdangOffice),
                siteName: siteInfo.siteName,
                siteNum: siteInfo.siteNum,
            }
        });
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleValueChange = (e) => {
        const { name, value, checked } = e.target;

        if (name === "siteNum") {
            this.setState({
                opbSearch: {
                    ...this.state.opbSearch,
                    [name]: value
                }
            });
        }
        else if (name === "searchTypeCodes") {
            this.setState({
                opbSearch: {
                    ...this.state.opbSearch,
                    searchTypeCodes: (checked ? this.state.opbSearch.searchTypeCodes.concat(value) : this.state.opbSearch.searchTypeCodes.filter(code => code !== value))
                }
            });
        }
    };

    handleSearchButton = () => {
        this.setState({
            contentsList: {
                ...this.state.contentsList,
                currentPage: 1
            }
        }, () => { this.setStateContentsList(); });
    };

    handleListCount = (e) => {
        this.setState({
            opbSearch: this.state.usedOpbSearch,
            contentsList: {
                ...this.state.contentsList,
                currentPage: 1,
                listCount: e.target.value
            }
        }, () => { this.setStateContentsList(); });
    };

    getCurrentPage = (currentPage) => {
        this.setState({
            opbSearch: this.state.usedOpbSearch,
            contentsList: {
                ...this.state.contentsList,
                currentPage: currentPage
            }
        }, () => { this.setStateContentsList(); })
    };

    render() {
        const { opbSearch, contentsList } = this.state;
        const { siteNum, searchTypeCodes } = opbSearch;
        const colgroupList = ["10%","10%","10%","10%","50%","10%"];
        const cellList = ["NO", "PrjNo", "유형", "썸네일", "텍스트", "더보기"];
        const selectList = ["10", "20", "50"];

        return (
            <React.Fragment>
                <h2 className="s-page-tit">
                    컨텐츠 검색
                </h2>
                <div className="search-wrapper contents-all-search s-normal-box">
                    <Row>
                        <Col xs={3} md={3} lg={2} className="col search-title">PrjNo</Col>
                        <Col xs={9} md={9} lg={4} className="col">
                            <SiteNumInputSiteFinder opbSearch={opbSearch} siteNum={siteNum} handleValueChange={this.handleValueChange} handleSiteInfo={this.handleSiteInfo} />
                        </Col>
                        <Col xs={3} md={3} lg={1} className="col search-title">유형</Col>
                        <Col xs={9} md={9} lg={5} className="col">
                            <Row className="">
                                <Col>
                                    <label className="w100per" >
                                        <Checkbox name="searchTypeCodes"
                                            value="CK002"
                                            color="primary"
                                            onChange={this.handleValueChange}
                                            checked={searchTypeCodes.indexOf("CK002") > -1}
                                        />
                                        이미지
                                    </label>
                                </Col>
                                <Col>
                                    <label className="w100per" >
                                        <Checkbox name="searchTypeCodes"
                                            value="CK003"
                                            color="primary"
                                            onChange={this.handleValueChange}
                                            checked={searchTypeCodes.indexOf("CK003") > -1}
                                        />
                                        동영상
                                    </label>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <div className="search-button-wrapper">
                    <button className="button w100-button contents-all-search-button" onClick={this.handleSearchButton}>검색</button>
                </div>
                <div className="search-result-wrapper contents-all-mng s-normal-box">
                    <Row className="search-result-top">
                        <Col xs={12} md={5} lg={5} className="">
                            <span>검색결과: {contentsList.totalCount}</span>
                            <span><button className="button w98-button white-button" name="초기화" onClick={this.setRefresh}><img src="/assets/images/ic-refresh.svg" alt="초기화" className="ic-refresh" />초기화</button></span>
                        </Col>
                        <Col xs={12} md={7} lg={7} className="text-align-right">
                            <select className="input-box padding-l10" name="listCount" value={contentsList.listCount} onChange={this.handleListCount}>
                                {selectList.map((select, i) => {
                                    return <option key={i} value={select}>{select}건</option>;
                                })}
                            </select>
                        </Col>
                    </Row>
                    <div style={{ overflow: "auto" }}>
                        <table style={{ width: this.state.isMobile ? '900px' : '100%' }}>
                            <colgroup>
                                {colgroupList.map((col, index) => {
                                    return <col key={index} width={col} />;
                                })}
                            </colgroup>
                            <thead className="table-head">
                                <tr>
                                    {cellList.map((cell, i) => {
                                        return <th className="" key={i}>{cell}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {(contentsList.boardList && contentsList.boardList.length > 0)
                                    ?
                                    contentsList.boardList.map((board, i) => {
                                        return <ContentsAllItem key={i} no={contentsList.totalCount - (contentsList.start + i) + 1} board={board} />;
                                    })
                                    :
                                    <tr>
                                        <td className="text-align-center" colSpan={cellList.length}>
                                            <div className="h300">
                                                <img style={{ marginTop: '90px' }} src={"/assets/images/ic-no-data.svg"} alt="데이터없음" /><br /><br />
                                                데이터가 없습니다.
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <Pagination list={contentsList} getCurrentPage={this.getCurrentPage} />
            </React.Fragment>
        );
    }
}


function mapState(state) {
    const { userinfo } = state;
    const myInfo = userinfo.item;
    return { myInfo };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(ContentsAllMng);